// extracted by mini-css-extract-plugin
module.exports = {"Audio":"Audio_Audio__vk2Uu","active":"Audio_active__24w8A","AudioTitle":"Audio_AudioTitle__2hsdn"};